import weu from './weu';
import weubeauty from './weubeauty';
import { AppTheme } from './types';

const themeMap: Record<string, AppTheme> = {
  weu,
  weubeauty,
};

const themeName = import.meta.env.VITE_APP_THEME ?? 'weu';
const selectedTheme = themeMap[themeName];

if (!selectedTheme) {
  console.warn(`Theme "${themeName}" not found. Falling back to default theme: weu`);
}

export default selectedTheme ?? weu;
